$(document).ready(function () {
  $("#mobileMenuButton").click(function () {
    $("#mobileNav").slideToggle();
  });

  $("#mobileNav a").click(function () {
    $("#mobileNav").slideToggle();
  });

  $(".heading-24").click(function () {
    window.scrollTo(0, 0);
  });

  var header = $("#shopify-section-header");
  var headerOffset = header.offset().top;

  $(window).on("scroll", function () {
    if ($(window).scrollTop() > headerOffset) {
      //header.addClass("sticky");
    } else {
      //header.removeClass("sticky");
    }
  });

  function checkCustomVisibility() {
    $(".customFadeInElement").each(function () {
      var elementTop = $(this).offset().top;
      var elementBottom = elementTop + $(this).outerHeight();
      var viewportTop = $(window).scrollTop();
      var viewportBottom = viewportTop + $(window).height();

      if (elementBottom > viewportTop && elementTop < viewportBottom) {
        $(this).addClass("customVisible");
      }
    });
  }

  $(window).on("scroll resize", checkCustomVisibility);
  $(window).trigger("scroll");

  $(window).on(
    "resize",
    debounce(function () {
      //location.reload();
    }, 250)
  );

  function debounce(func, wait) {
    var timeout;
    return function () {
      clearTimeout(timeout);
      timeout = setTimeout(func, wait);
    };
  }

  // Add active class on click
  $(".nav-link-3.scrollToAnchorLink").on("click", function (event) {
    event.preventDefault();
    $(".nav-link-3").removeClass("active");
    $(this).addClass("active");

    var target = $(this).attr("href");
    $("html, body").animate(
      {
        scrollTop: $(target).offset().top,
      },
      500
    );
  });

  const $desktopLaptopNav = $("#desktopLaptopNav");

  function handleNavLinksScroll() {
    $(window).on("scroll.navLinks", function () {
      var scrollPos = $(window).scrollTop();

      $(".nav-link-3").each(function () {
        var href = $(this).attr("href");
        var target = $(href);

        var sectionOffset = target.offset().top - 100;

        if (scrollPos >= sectionOffset) {
          $(".nav-link-3").removeClass("active");
          $(this).addClass("active");
        }
      });
    });
  }

  function handleDesktopScroll() {
    $("#webflowNav").hide();
    $(window)
      .on("scroll.desktopNav", function () {
        if ($(this).scrollTop() >= 1200) {
          $desktopLaptopNav.addClass("hiddenDiv");
          $("#webflowNav").show();
        } else {
          $desktopLaptopNav.removeClass("hiddenDiv");
          $("#webflowNav").hide();
        }
      })
      .trigger("scroll");
  }

  function adjustVisibility() {
    if ($(window).width() <= 1024) {
      $desktopLaptopNav.addClass("hiddenDiv");
      $(window).off("scroll.desktopNav");
    } else {
      handleDesktopScroll();
    }
  }

  //adjustVisibility();
  handleDesktopScroll();
  //handleNavLinksScroll();

  //$(window).on("resize", adjustVisibility);
});

$(document).ready(function () {
  function triggerViewportAnimations() {
    $(".viewport-anim-element").each(function (index) {
      const $element = $(this);
      const elementOffsetTop = $element.offset().top;
      const scrollTop = $(window).scrollTop();
      const windowHeight = $(window).height();

      if (scrollTop + windowHeight > elementOffsetTop) {
        setTimeout(() => {
          $element.addClass("viewport-anim-visible");
        }, index * 10); // Delay for cascading effect
      }
    });
  }

  $(window).on("scroll", triggerViewportAnimations);
  $(window).on("load", triggerViewportAnimations); // Trigger animation on page load

  function triggerViewportAnimations2() {
    $(".viewport-anim-element2").each(function (index) {
      const $element = $(this);
      const elementOffsetTop = $element.offset().top;
      const scrollTop = $(window).scrollTop();
      const windowHeight = $(window).height();

      if (scrollTop + windowHeight > elementOffsetTop) {
        setTimeout(() => {
          $element.addClass("viewport-anim-visible2");
        }, index * 100); // Delay for cascading effect
      }
    });
  }

  $(window).on("scroll", triggerViewportAnimations2);
  $(window).on("load", triggerViewportAnimations2); // Trigger animation on page load

  var $filmstripInner = jQuery(".expert-filmstrip-inner");
  var $clonedContent = $filmstripInner.html();
  $filmstripInner.append($clonedContent); // Duplicate for seamless loop

  var $filmstripInner2 = jQuery(".expert-filmstrip-inner2");
  var $clonedContent2 = $filmstripInner2.html();
  $filmstripInner2.append($clonedContent2); // Duplicate for seamless loop
});

/*
document.addEventListener("DOMContentLoaded", () => {
  const uniqueCounterElement = document.getElementById("uniqueCounter");
  const uniqueCounterTargetValue = 5000000; // End value
  const uniqueCounterDuration = 1500; // Animation duration in ms
  const uniqueCounterInterval = 10; // Interval in ms

  const uniqueCounterObserver = new IntersectionObserver(
    (entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          // Start counter animation
          let uniqueCounterCurrentValue = 0;
          const uniqueCounterSteps =
            uniqueCounterDuration / uniqueCounterInterval;
          const uniqueCounterIncrement = Math.ceil(
            uniqueCounterTargetValue / uniqueCounterSteps
          );

          const uniqueCounterIntervalId = setInterval(() => {
            uniqueCounterCurrentValue += uniqueCounterIncrement;
            if (uniqueCounterCurrentValue >= uniqueCounterTargetValue) {
              uniqueCounterCurrentValue = uniqueCounterTargetValue;
              clearInterval(uniqueCounterIntervalId);
            }
            $("#uniqueCounter").text(
              uniqueCounterCurrentValue.toLocaleString()
            );
          }, uniqueCounterInterval);

          observer.unobserve(uniqueCounterElement); // Stop observing once animation starts
        }
      });
    }
  );

  uniqueCounterObserver.observe(uniqueCounterElement);
});
*/

// Menu functions - consolidated
$(document).ready(function () {
  $(".burger-menu1A").click(function () {
    if ($(".main-content-container1").hasClass("menu-open")) {
      $(".main-content-container1").removeClass("menu-open");
      $(".mobile-menu1B").css("left", "-250px");
      $("body").removeClass("no-scroll"); // Re-enable scrolling
    } else {
      $(".main-content-container1").addClass("menu-open");
      $(".mobile-menu1B").css("left", "0");
      $("body").addClass("no-scroll"); // Disable scrolling
    }
  });

  function toggleMenu(buttonClass, panelId) {
    $(buttonClass).click(function () {
      var $panelCollapse = $(panelId);
      var $icon = $(this).find(".lin");

      // Close any open panels
      $("#pushy-menu .panel-collapse.in")
        .not($panelCollapse)
        .slideUp()
        .removeClass("in");
      $("#pushy-menu .lin-arrow-up")
        .not($icon)
        .removeClass("lin-arrow-up")
        .addClass("lin-arrow-down");

      // Toggle the clicked panel
      if ($panelCollapse.is(":visible")) {
        $panelCollapse.slideUp().removeClass("in");
        $icon.removeClass("lin-arrow-up").addClass("lin-arrow-down");
      } else {
        $panelCollapse.slideDown().addClass("in");
        $icon.removeClass("lin-arrow-down").addClass("lin-arrow-up");
      }
    });

    $("#pushy-menu .lin.lin-arrow-down").on("click", function () {
      $(this).toggleClass("lin-arrow-down lin-arrow-up");
    });
  }

  toggleMenu(
    "#pushy-menu .second_level_drop_link.products_2Button",
    "#pushy-menu #products_2"
  );
  toggleMenu(
    "#pushy-menu .second_level_drop_link.services_2Button",
    "#pushy-menu #services_2"
  );
  toggleMenu(
    "#pushy-menu .second_level_drop_link.support_4Button",
    "#pushy-menu #support_4"
  );

  // Show dialog and disable vertical scroll
  $("#nav-search-dialog-button").on("click", function () {
    $("#nav-search-dialog").show();
    $("#nav-search-dialog").attr("style", "display: block !important;");
    $("body").css("overflow", "hidden");
  });

  // Hide dialog and enable vertical scroll
  $("#nav-search-dialog-exit").on("click", function () {
    $("#nav-search-dialog").hide();
    $("#nav-search-dialog").attr("style", "display: none !important;");
    $("body").css("overflow", "auto");
  });

  $(".dropdown-products, .dropdown-support, .dropdown-services").hover(
    function () {
      $(this).closest(".dropdown").find(".dropdown-menu").show();
    },
    function () {
      $(this).closest(".dropdown").find(".dropdown-menu").hide();
    }
  );

  $(".dropdown-menu").hover(
    function () {
      $(this).show();
    },
    function () {
      $(this).hide();
    }
  );

  $(".lin.lin-arrow-down").on("click", function () {
    $(this).toggleClass("lin-arrow-down lin-arrow-up");
  });

  $("#closeMobileMenu, .no-scroll").on("click", function () {
    $("#pushy-menu-btn").trigger("click");
  });
});

// Videos

$(document).ready(function () {
  /*
  $("#repairSolutions2AppVideo").on("click", function () {
    const video = $("#appVideo")[0];
    video.currentTime = 0;
    video.play();
    $("body").addClass("no-scroll2");
    $("#videoModal1, #videoModal1background").show();
  });*/

  function updateBackgroundVideoHeight() {
    var showcaseHeight = $("#innova5610Showcase").outerHeight();
    $("#innova5610Showcase #backgroundVideo").css("min-height", showcaseHeight);
  }
  updateBackgroundVideoHeight();
  $(window).resize(updateBackgroundVideoHeight);

  $("#closeRS2appVideo").on("click", function () {
    /* const video = $("#appVideo")[0];
    video.pause();
    video.currentTime = 0;*/
    $("body").removeClass("no-scroll2");
    $("#videoModal1, #videoModal1background").hide();
    $("#videoPlayerWrapper2").empty();
    //$("#firstThumbnail").click();
  });

  $(".openImageModal").click(function (e) {
    e.preventDefault();

    var src = $(this).data("src");
    var content =
      '<img src="' +
      src +
      '" alt="Preview Image" style="max-width:100%; height:auto;">';

    $("#videoPlayerWrapper2").removeClass().html(content).addClass("image");
    $("body").addClass("no-scroll2");
    $("#videoModal1, #videoModal1background").show();
  });

  $("a.openVideoModal1, .youTubeReference1").click(function (e) {
    e.preventDefault(); // Prevent default link behavior

    var type = $(this).data("type");
    var src = $(this).data("src");
    var content = "";

    if (type === "youtube") {
      // Embed YouTube video
      content =
        '<iframe width="560" height="315" src="https://www.youtube.com/embed/' +
        src +
        '" ' +
        'frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" ' +
        "allowfullscreen></iframe>";
    } else if (type === "tiktok") {
      // Extract video ID from the TikTok URL (assumes video ID is the last segment)
      var parts = src.split("/");
      var videoId = parts.pop() || parts.pop();
      content =
        '<blockquote class="tiktok-embed" cite="' +
        src +
        '" data-video-id="' +
        videoId +
        '" style="max-width: 605px;min-width: 325px;">' +
        "<section></section>" +
        "</blockquote>" +
        '<script async src="https://www.tiktok.com/embed.js"></script>';
    } else if (type === "mp4") {
      // Embed MP4 video
      content =
        '<video id="appVideo" width="600" autoplay controls>' +
        '<source src="' +
        src +
        '" type="video/mp4">' +
        "Your browser does not support the video tag." +
        "</video>";
    }

    //var exitVideoButton = "<div id=\"closeRS2appVideo\"><svg width=\"15\" height=\"15\" viewBox=\"0 0 15 15\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M14.781 13.7198C14.8507 13.7895 14.906 13.8722 14.9437 13.9632C14.9814 14.0543 15.0008 14.1519 15.0008 14.2504C15.0008 14.349 14.9814 14.4465 14.9437 14.5376C14.906 14.6286 14.8507 14.7114 14.781 14.781C14.7114 14.8507 14.6286 14.906 14.5376 14.9437C14.4465 14.9814 14.349 15.0008 14.2504 15.0008C14.1519 15.0008 14.0543 14.9814 13.9632 14.9437C13.8722 14.906 13.7895 14.8507 13.7198 14.781L7.50042 8.56073L1.28104 14.781C1.14031 14.9218 0.94944 15.0008 0.750417 15.0008C0.551394 15.0008 0.360523 14.9218 0.219792 14.781C0.0790615 14.6403 3.92322e-09 14.4494 0 14.2504C-3.92322e-09 14.0514 0.0790615 13.8605 0.219792 13.7198L6.4401 7.50042L0.219792 1.28104C0.0790615 1.14031 0 0.94944 0 0.750417C0 0.551394 0.0790615 0.360523 0.219792 0.219792C0.360523 0.0790615 0.551394 0 0.750417 0C0.94944 0 1.14031 0.0790615 1.28104 0.219792L7.50042 6.4401L13.7198 0.219792C13.8605 0.0790615 14.0514 -3.92322e-09 14.2504 0C14.4494 3.92322e-09 14.6403 0.0790615 14.781 0.219792C14.9218 0.360523 15.0008 0.551394 15.0008 0.750417C15.0008 0.94944 14.9218 1.14031 14.781 1.28104L8.56073 7.50042L14.781 13.7198Z\" fill=\"white\"></path></svg></div>";

    // Load content into modal and show it
    $("#videoPlayerWrapper2")
      .removeClass("youtube")
      .removeClass("tiktok")
      .removeClass("mp4");
    $("#videoPlayerWrapper2").html(content).addClass(type);
    $("body").addClass("no-scroll2");
    $("#videoModal1, #videoModal1background").show();
  });

  let observer = new IntersectionObserver(
    function (entries) {
      entries.forEach((entry) => {
        let video = $(entry.target).find("video")[0]; // Get the video inside the row
        if (entry.isIntersecting) {
          video.play();
        } else {
          video.pause();
          video.currentTime = 0; // Reset video when out of view
        }
      });
    },
    { threshold: 0.5 }
  ); // Adjust threshold if needed

  $(
    "#knowWhatAboutYourCar .row .actualImageWrapper, #americanEngineering .video-wrapper"
  ).each(function () {
    observer.observe(this);
  });
});

// Social Media Slider
$(document).ready(function () {
  var $slider = $(".customSlider-slider"),
    $slidesContainer = $slider.find(".customSlider-slides"),
    $slides = $slidesContainer.find(".customSlider-slide"),
    currentIndex = 0,
    totalSlides = $slides.length;

  function getSlidesToShow() {
    return $(window).width() >= 768 ? 2.5 : 1;
  }

  function goToSlide(index) {
    if (index < 0) index = totalSlides - 1;
    else if (index >= totalSlides) index = 0;
    var slidesToShow = getSlidesToShow();
    $slidesContainer.css(
      "transform",
      "translateX(" + -index * (100 / slidesToShow) + "%)"
    );
    currentIndex = index;
    updatePagination();
  }

  function updatePagination() {
    $(".customSlider-pagination li")
      .removeClass("active")
      .eq(currentIndex)
      .addClass("active");
  }

  $(".customSlider-next").click(function () {
    goToSlide(currentIndex + 1);
  });
  $(".customSlider-prev").click(function () {
    goToSlide(currentIndex - 1);
  });

  $(".customSlider-pagination li").click(function () {
    var index = $(this).data("index");
    goToSlide(index);
  });

  var startX, moveX;
  $slidesContainer.on("touchstart", function (e) {
    startX = e.originalEvent.touches[0].pageX;
  });
  $slidesContainer.on("touchmove", function (e) {
    moveX = e.originalEvent.touches[0].pageX;
  });
  $slidesContainer.on("touchend", function () {
    var diff = moveX - startX;
    if (Math.abs(diff) > 50) {
      diff > 0 ? goToSlide(currentIndex - 1) : goToSlide(currentIndex + 1);
    }
  });

  $(window).resize(function () {
    goToSlide(currentIndex);
  });
});

// Tooltip
$(document).ready(function () {
  const jsonData = {
    "autoReLink-icon":
      "Auto-Relink automatically re-scans the vehicle at regular intervals, ensuring readiness monitors and key parameters are updated for SMOG testing and emissions compliance.",
    "codePriority-icon":
      "Code Priority refers to identifying the main fault code responsible for triggering your dashboard light. In many cases, resolving the primary fault code can also address related secondary codes that appear afterward.",
    "driveCycleProcedures-icon":
      "Drive Cycle Procedures refers to the ability of guiding you through each specific driving step to reset monitors for SMOG testing with real time instructions.",
    "bidirectionalSystemTest-icon":
      "Bidirectional System Tests let you control vehicle systems to identify issues. Common tests include actuator tests, EVAP system tests, injector balance tests, and solenoid tests.",
    "specialFunctionsRoutinesCalibrations-icon":
      "Special Functions refer to special reset features like SAS, DPF regen, EVAP VSV check, and more.",
    "all10ObdModes-icon":
      "<strong>Mode 01</strong> - I/M Readiness Status/Live Data Mode (PIDs)<br><strong>Mode 02</strong> - Freeze Frame Data<br><strong>Mode 03</strong> - Emission Related DTCs<br><strong>Mode 04</strong> - Erase DTCs<br><strong>Mode 05</strong> - Request O2 test results<br><strong>Mode 06</strong> - I/M Monitor Tests/Monitoring test results and parameters<br><strong>Mode 07</strong> - Two Trip Pending Diagnostic Trouble Code<br><strong>Mode 08</strong> - Request control of Onboard Component<br><strong>Mode 09</strong> - Request vehicle info<br><strong>Mode 10</strong> or <strong>Mode 0a</strong> - Permanent DTC",
    "all8ObdModes-icon":
      "<strong>Mode 01</strong> - I/M Readiness Status/Live Data Mode (PIDs)<br><strong>Mode 02</strong> - Freeze Frame Data<br><strong>Mode 03</strong> - Emission Related DTCs<br><strong>Mode 04</strong> - Erase DTCs<br><strong>Mode 05</strong> - Request O2 test results<br><strong>Mode 07</strong> - Two Trip Pending Diagnostic Trouble Code<br><strong>Mode 09</strong> - Request vehicle info<br><strong>Mode 10</strong> or <strong>Mode 0a</strong> - Permanent DTC",
    "secureGatewayForFCAvehicles-icon":
      "Secure Gateway access enables select scanners to unlock FCA vehicles' secure gateway by connecting through an AutoAuth account.",
    "batteryTooltip-unused": "Long-lasting battery life for extended usage.",
  };

  let activeTooltip = null;

  // Event delegation for dynamically added elements
  $("body").on("click", ".tooltipForComparo-trigger", function (e) {
    e.stopPropagation();

    // Close any existing tooltip
    if (activeTooltip) {
      activeTooltip.remove();
      activeTooltip = null;
    }

    const $trigger = $(this);
    const uniqueClass = $trigger
      .attr("class")
      .split(" ")
      .find((cls) => jsonData[cls]);

    const tooltipText = jsonData[uniqueClass] || "Tooltip not available.";

    // Create the tooltip dynamically
    const $tooltip = $('<div class="tooltipForComparo"></div>').html(
      tooltipText
    );

    // Append tooltip to the body
    $("body").append($tooltip);

    // Position the tooltip
    const rect = $trigger[0].getBoundingClientRect();
    const left = rect.left + window.scrollX;
    const top = rect.top + window.scrollY - $tooltip.outerHeight() - 10;

    $tooltip.css({
      left: `${left}px`,
      top: `${top}px`,
      display: "block",
    });

    activeTooltip = $tooltip;
  });

  // Close tooltip on outside click
  $(document).on("click", function () {
    if (activeTooltip) {
      activeTooltip.remove();
      activeTooltip = null;
    }
  });

  // Close tooltip on scroll
  $("#productComparo").on("scroll", function () {
    if (activeTooltip) {
      activeTooltip.remove();
      activeTooltip = null;
    }
  });

  // Handle tooltips inside Bootstrap modals
  $(document).on("shown.bs.modal", function (e) {
    const $modal = $(e.target);

    $modal.on("click", ".tooltipForComparo-trigger", function (e) {
      e.stopPropagation();

      // Close any existing tooltip
      if (activeTooltip) {
        activeTooltip.remove();
        activeTooltip = null;
      }

      const $trigger = $(this);
      const uniqueClass = $trigger
        .attr("class")
        .split(" ")
        .find((cls) => jsonData[cls]);

      const tooltipText = jsonData[uniqueClass] || "Tooltip not available.";

      // Create the tooltip dynamically
      const $tooltip = $('<div class="tooltipForComparo"></div>').html(
        tooltipText
      );

      // Append tooltip to the modal
      $modal.append($tooltip);

      // Position the tooltip
      const rect = $trigger[0].getBoundingClientRect();
      const left = rect.left;
      const top = rect.top - $tooltip.outerHeight() - 10;

      $tooltip.css({
        left: `${left}px`,
        top: `${top}px`,
        display: "block",
      });

      activeTooltip = $tooltip;
    });

    // Close tooltip on scroll inside the modal
    $modal.on("scroll", function () {
      if (activeTooltip) {
        activeTooltip.remove();
        activeTooltip = null;
      }
    });
  });
});

// Custom Scrollbar
$(document).ready(function () {
  const $deviceComparo = $("#productComparo");
  const $scrollbarThumb = $(".custom-scrollbar-thumb");

  function updateScrollbar() {
    const scrollWidth =
      $deviceComparo[0].scrollWidth - $deviceComparo[0].clientWidth;
    const scrollLeft = $deviceComparo.scrollLeft();
    const thumbWidth = (scrollLeft / scrollWidth) * 100;

    // Ensure the thumb is always visible, even at the initial position
    $scrollbarThumb.css("width", Math.max(thumbWidth, 50) + "%");
  }

  // Initialize the scrollbar thumb
  updateScrollbar();
  $deviceComparo.on("scroll", updateScrollbar);
});

// Streamline Repairs. Minimize Guesswork.
/*$(".accordion2Columns .accordion-button").on("click", function () {
  var newImg = $(this).data("img");
  $("#customMainImage").attr("src", newImg);
});

$(".accordion2Columns .custom-accordion .accordion-collapse").on(
  "show.bs.collapse",
  function () {
    $(".accordion2Columns .custom-accordion .accordion-collapse.show")
      .not(this)
      .collapse("hide");
  }
);*/

// Interactive Image Scroll
/*let resizedInteractive = false; // flag

$(window).on("scroll resize load", function () {
  const $el = $("#imageWrapperInteractive");
  const elTop = $el.offset().top;
  const elBottom = elTop + $el.outerHeight();
  const scrollTop = $(window).scrollTop();
  const windowHeight = $(window).height();
  const center = scrollTop + windowHeight / 2;
  const isMobile = window.innerWidth <= 768;

  const isCentered = center > elTop && center < elBottom;

  if (isCentered && !resizedInteractive) {
    $el.css("width", isMobile ? "100vw" : "1040px");
    resizedInteractive = true;
  } else if (!isCentered && resizedInteractive && center < elTop) {
    // Only reset if user scrolls back above
    $el.css("width", "100vw");
    resizedInteractive = false;
  }
});*/

/*
$(function () {
  const $win = $(window);
  const $el = $("#imageWrapperInteractive");
  const $img = $el.find("img");
  const startY = window.innerHeight * 0.4;
  const mobileMax = 768;
  const desktopW = 1040;
  const speed = 1; // ← finish 50% faster (tweak this)

  function update() {
    const rect = $el[0].getBoundingClientRect();
    const top = rect.top;

    // 1) raw goes 0→1 as top moves startY→0
    let raw = (startY - top) / startY;
    // 2) speed it up by multiplying (so raw*1.5 hits 1 when raw=0.666…)
    let prog = Math.min(Math.max(raw * speed, 0), 1);

    // scrub opacity
    $img.css("opacity", prog);

    // scrub width on desktop
    if (window.innerWidth > mobileMax) {
      const vw = window.innerWidth;
      const widthPx = vw * (1 - prog) + desktopW * prog;
      $el.css("width", widthPx + "px");
    } else {
      $el.css("width", "100vw");
    }
  }

  $win.on("scroll resize load", update);
});

$(document).ready(function () {
  let originalContent = $(".credit-scroll-text").html();
  let repeatedContent = "";

  for (let i = 0; i < 12; i++) {
    repeatedContent += "<br><br><br><br><br><br>" + originalContent;
  }

  $(".credit-scroll-text").html(repeatedContent);
});*/

// American Engineering - Parallax video
/*$(document).ready(function () {
  let totalFrames = 90; // For a 3s video at 30 FPS
  let targetTime = 0;
  let currentTime = 0;
  let lastTargetTime = 0;
  const smoothingDown = 0.1; // When scrolling down
  const smoothingUp = 0.3; // When scrolling up (faster easing)

  function updateScrollVideo() {
    const $video = $("#scroll-video")[0];
    const $wrapper = $(".video-wrapper");
    const scrollTop = $(window).scrollTop();
    const offsetTop = $wrapper.offset().top;
    const wrapperHeight = $wrapper.height();

    // Define active zone: scrubbing happens when the wrapper's center is in view
    const triggerStart = offsetTop - window.innerHeight * 0.75;
    const triggerEnd = offsetTop + wrapperHeight - window.innerHeight * 0.25;
    const scrollInZone = Math.min(
      Math.max(scrollTop - triggerStart, 0),
      triggerEnd - triggerStart
    );
    const scrollProgress = scrollInZone / (triggerEnd - triggerStart);

    if ($video.duration) {
      // Map scroll progress to a discrete frame (0 to 59)
      const frameIndex = Math.round(scrollProgress * (totalFrames - 1));
      const newTargetTime = frameIndex * ($video.duration / totalFrames);

      // Use a faster easing factor when scrolling upward
      const factor =
        newTargetTime < lastTargetTime ? smoothingUp : smoothingDown;
      lastTargetTime = newTargetTime;
      targetTime = newTargetTime;

      // Smoothly interpolate currentTime towards targetTime
      currentTime += (targetTime - currentTime) * factor;
      $video.currentTime = currentTime;
    }

    requestAnimationFrame(updateScrollVideo);
  }

  updateScrollVideo();
});*/

// Award-Winning OBD2 Scanners - Carousel
$(document).ready(function () {
  // Play the first video in the specified selector
  var firstVideo = $(
    "#bestOBD2 #customCarouselV2 .carousel-item video"
  ).first();

  if (firstVideo.length > 0) {
    firstVideo.get(0).play();
  } else {
    console.log("No videos found in the selector.");
  }
  $("#customCarouselV2").slick({
    autoplay: true,
    autoplaySpeed: 10000,
    arrows: true,
    dots: true,
    centerMode: true,
    centerPadding: "15%",
    focusOnSelect: true,
    respondTo: "slider",
    draggable: false,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          centerMode: false,
        },
      },
    ],
  });
  $("#customCarouselV2").on(
    "afterChange",
    function (event, slick, currentSlide) {
      console.log("Current slide is:", currentSlide);

      // Pause all videos inside #customCarouselV2
      $("#customCarouselV2 video").each(function () {
        this.pause();
      });

      // Play the video in the current slide of #customCarouselV2
      var currentVideo = $("#customCarouselV2")
        .find(".slick-slide[data-slick-index='" + currentSlide + "']")
        .find("video");
      if (currentVideo.length > 0) {
        currentVideo.get(0).play();
      }
      $("#bestOBD2 #customCarouselV2 .slick-active .magazineQuote").animate(
        { left: "+=1px" },
        10,
        function () {
          $(this).animate({ left: "-=1px" }, 10);
        }
      );
      $("#bestOBD2 #customCarouselV2 .slick-active .magazineQuote").click(
        function () {
          $("#bestOBD2 #customCarouselV2 .slick-active .magazineQuote").trigger(
            "touchstart"
          );
          $("#bestOBD2 #customCarouselV2 .slick-active .magazineQuote").animate(
            { top: "+=1px" },
            10,
            function () {
              $(this).animate({ top: "-=1px" }, 10);
            }
          );
        }
      );
      //$("#bestOBD2 #customCarouselV2 .slick-active .magazineQuote").click();
    }
  );
});

// Pulse Animations - Showcase Callout Animations
let hasPlayedOnce = false;
let animationRunning = false;
let wasVisible = false; // track viewport status

$(".showcaseText1, .showcaseText2, .showcaseText3").hide().css({ opacity: 0 });

function startShowcaseSequence() {
  animationRunning = true;

  $(".showcaseArrow1, .showcaseArrow2, .showcaseArrow3").each(function () {
    $(this)
      .show()
      .css({
        opacity: 1,
        overflow: "hidden",
        width: "0",
        direction: $(this).hasClass("showcaseArrow1") ? "ltr" : "rtl",
      });
  });

  $(".showcaseText1").delay(0).fadeTo(500, 1);
  $(".showcaseText2").delay(500).fadeTo(500, 1);
  $(".showcaseText3").delay(1000).fadeTo(500, 1);

  setTimeout(() => $(".showcaseArrow1").animate({ width: "100%" }, 500), 1500);
  setTimeout(() => $(".showcaseArrow2").animate({ width: "100%" }, 500), 2300);
  setTimeout(() => {
    $(".showcaseArrow3").animate({ width: "100%" }, 500, () => {
      if (hasPlayedOnce) {
        setTimeout(() => {
          $(".showcaseText1, .showcaseText2, .showcaseText3").fadeOut(1000);
          $(".showcaseArrow1, .showcaseArrow2, .showcaseArrow3").fadeOut(
            1000,
            () => {
              animationRunning = false;
            }
          );
        }, 20000);
      } else {
        animationRunning = false;
        hasPlayedOnce = true;
      }
    });
  }, 3100);
}

// Observer for entering/leaving viewport
const observer = new IntersectionObserver(
  (entries) => {
    const entry = entries[0];

    if (entry.isIntersecting && !wasVisible && !animationRunning) {
      wasVisible = true; // now visible
      setTimeout(() => {
        if (!animationRunning) startShowcaseSequence();
      }, 500);
    } else if (!entry.isIntersecting) {
      wasVisible = false; // fully left the viewport
    }
  },
  {
    threshold: 0.2,
  }
);

//observer.observe(document.querySelector("#productShowcase1"));

/* Pulse Animations Text */
$(document).ready(function () {
  let lastClicked = null;
  const messages = [
    "&ldquo;Most mechanics charge close to 200 bucks an hour to work on your car&hellip; for a little over an hour of labor you can get this.&rdquo;<br><br><span>-Scotty Kilmer</span>",
    "&ldquo;Even though this is an old car&hellip; [the Innova 5610] does 94 different live data streams&hellip; not just a handful of them.&rdquo;<br><br><span>-Scotty Kilmer</span>",
    "&ldquo;This is information that myself as a mechanic I got to pay extra for&hellip; This RepairSolutions2 is free&hellip; you already own a cell phone so you can use that to access all this information.&rdquo;<br><br><span>-Scotty Kilmer</span>",
  ];

  $(".pulseImage").each(function (index) {
    $(this).on("click", function () {
      if (lastClicked && lastClicked[0] !== this) {
        lastClicked.find(".clickedImageButton").fadeOut(200);
        lastClicked.find(".staticImageButton").fadeIn(200);
      }

      $(this).find(".staticImageButton").fadeOut(200);
      $(this).find(".clickedImageButton").fadeIn(200);

      $("#pulseText").html(messages[index]);

      lastClicked = $(this);
    });
  });
});

$(document).ready(function () {
  // Reset scroll on load
  setTimeout(function () {
    window.scrollTo(0, 0);
  }, 0);

  // Reset scroll on refresh
  $(window).on("beforeunload", function () {
    window.scrollTo(0, 0);
  });
});